import { Injectable, Inject } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { User } from './user.model';
import { SnackService } from '../../shared-services/snack.service';
import { SecurityService } from '../security.service';
import { BackendService } from '../../core/backend.service';

@Injectable()
export class UserChangePasswordResolver implements Resolve<any> {
  constructor(
    protected router: Router,
    protected snackService: SnackService,
    protected securityService: SecurityService,
    protected backendService: BackendService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      const id = route.params.id || 'me';

      if (id === 'me') {
        return { myPassword: true, user: null };
      }

      return { myPassword: false, user: await this.backendService.get(User, User.path + id).toPromise() };
    } catch (error) {
      this.router.navigate(['/usuarios']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/security/user/user-change-password.resolver.ts